<template>
    <div>
        <v-dialog v-model="show" no-click-animation persistent width="600">
            <div class="ScenarioDictionary">
                <!--Header dialog-->
                <div class="dialog-header">
                    <div>{{ $f.tc('dictionary') }}</div>
                    <v-btn small icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
                <!--Content dialog-->
                <div class="dialog-content fci-scrollbar" ref="contentDialog">
                    <div class="editor-actions">
                        <div class="btn-outline-delete btn-outline" @click="deleteAllDictionary"
                             style="margin-right: auto !important;" v-if="isEdit">
                            <img src="/img/delete_red.svg" alt="icon-delete"
                                 style="margin-right: 6px; transform: scale(1.1)">
                            {{ $f.tc('deleteAll') }}
                        </div>
                        <div class="btn-outline mr-6" @click="importDictionary" v-if="isEdit">
                            <img src="/img/add-blue.svg" alt="icon-add-mapping-excel"
                                 style="margin-right: 6px; transform: scale(1.1)">
                            {{ $f.tc('importFromExcel') }}
                            <input type="file" :hidden="true" ref="InputDictionary" accept=".xlsx, .xls, .csv"
                                   @change="handleFile" v-if="isEdit">
                        </div>
                        <div class="btn-outline mr-6" @click="downloadTemplate" v-if="isEdit"
                             :title="$f.tc('downloadTemplateExcel')">
                            <img src="/img/scenario/download_blue.svg" alt="icon-download-template"
                                 style="margin-right: 6px; transform: scale(1.1)">
                            {{ $f.tc('export') }}
                        </div>
                    </div>
                    <!--Table variables-->
                    <table>
                        <thead>
                        <tr>
                            <th>{{ $f.tc('acronym') }}</th>
                            <th>{{ $f.tc('pronoun') }}</th>
                            <th>Regex</th>
                            <th v-if="isEdit"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <!--Current variables-->
                        <tr v-for="(item, i) in itemList" :key="i">
                            <td>
                                <v-text-field
                                    outlined
                                    v-model="item.acronym"
                                    class="input-custom"
                                    style="width: 100%"
                                    :readonly="!isEdit"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    outlined
                                    v-model="item.pronoun"
                                    class="input-custom"
                                    style="width: 100%"
                                    :readonly="!isEdit"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-checkbox
                                    hide-details
                                    v-model="item['is_regex']"
                                    :disabled="!isEdit"
                                    color="#0052CC"
                                ></v-checkbox>
                            </td>
                            <td v-if="isEdit">
                                <v-btn icon class="mx-0" @click.stop="deleteItem(i)">
                                    <img src="/img/delete-blue.svg" alt="icon-delete"
                                         style="transform: scale(1.3); padding-left: 1px">
                                </v-btn>
                            </td>
                        </tr>
                        <!--New variable-->
                        <tr v-if="isEdit">
                            <td>
                                <v-text-field
                                    outlined
                                    v-model="acronym"
                                    class="input-custom"
                                    @keypress.enter="addItem"
                                    :placeholder="$f.tc('acronym')"
                                    style="width: 100%"
                                    ref="NewKeyVariable"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    outlined
                                    v-model="pronoun"
                                    class="input-custom"
                                    @keypress.enter="addItem"
                                    :placeholder="$f.tc('pronoun')"
                                    style="width: 100%"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-checkbox
                                    hide-details
                                    v-model="isRegex"
                                    :disabled="!isEdit"
                                    color="#0052CC"
                                ></v-checkbox>
                            </td>
                            <td>
                                <v-btn icon class="mx-0" @click.stop="addItem">
                                    <img src="/img/add-blue.svg" alt="icon-delete" style="transform: scale(1.4);">
                                </v-btn>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <!--Footer dialog-->
                <div class="dialog-footer" v-if="isEdit">
                    <div class="btn-custom"
                         @click="saveList">{{ $f.tc('save') }}
                    </div>
                    <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
                </div>
            </div>
        </v-dialog>
        <ConfirmDeleteAllDictionary
            ref="ConfirmDeleteAllDictionary"
        ></ConfirmDeleteAllDictionary>
    </div>
</template>

<script>
import DialogPromiseMixin from '@/modules/fptai/mixins/DialogPromiseMixin'
import ScenarioService from '@/services/scenario.service'
import lodash from 'lodash'
import { mapState } from 'vuex'
import ConfirmDeleteAllDictionary from '@/views/Scenario/nlp/ConfirmDeleteAllDictionary.vue'
import $const from '@/utils/const'

export default {
    name: 'ScenarioDictionary',
    components: { ConfirmDeleteAllDictionary },
    mixins: [DialogPromiseMixin],
    data () {
        return {
            acronym: '',
            pronoun: '',
            isRegex: false,
        }
    },
    computed: {
        ...mapState({
            dictionaryList: state => state.scenario.dictionaryTtsList,
            scenario: state => state.scenario.scenario
        }),
        isEdit () {
            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        },
        itemList () {
            return lodash.orderBy(this.$utils.cloneObject(this.dictionaryList), 'acronym')
        },
        originalItemMap () {
            let map = {}
            for (let item of this.dictionaryList) {
                map[item.acronym] = item
            }
            return map
        }
    },
    destroyed () {
        this.$store.commit(this.$actionTypes.scenario.DICTIONARY_TTS, [])
    },
    methods: {
        loadDictionary () {
            this.$store.dispatch(this.$actionTypes.scenario.GET_DICTIONARY_TTS, this.$route.params.scenarioId)
        },
        resetData() {
            this.acronym = ''
            this.pronoun = ''
            this.isRegex = false
        },
        open () {
            this.resetData()
            this.loadDictionary()

            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        addItem () {
            if (this.nameIsEmpty()) {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', { item: this.$f.tc('acronym') }))
                return
            }
            if (this.nameIsExist()) {
                this.$appService.toastError(this.$f.tc('fieldItemDuplicate', {
                    key: this.$f.tc('acronym'),
                    value: this.acronym
                }))
                return
            }
            this.itemList.push({
                acronym: this.acronym,
                pronoun: this.pronoun,
                is_regex: this.isRegex
            })
            this.scrollBottom()
            this.resetData()
            this.$refs.NewKeyVariable.$el.focus()
        },
        nameIsEmpty () {
            return !this.acronym
        },
        nameIsExist () {
            let item = this.itemList.find(item => item.acronym === this.acronym)
            return !!item
        },
        deleteItem (index) {
            this.itemList.splice(index, 1)
            this.$forceUpdate()
        },
        saveList () {
            let addList = []
            let updateList = []
            let deleteList = []
            for (let item of this.itemList) {
                item['acronym'] = item['acronym'].trim()
                item['pronoun'] = item['pronoun'].trim()
                let originalItem = this.originalItemMap[item.acronym]
                if (originalItem) {
                    originalItem.doNotDelete = true
                    if (
                        item.pronoun !== originalItem.pronoun ||
                        item.is_regex !== originalItem.is_regex
                    ) {
                        item.id = originalItem.id

                        updateList.push(item)
                    }
                } else {
                    addList.push(item)
                }
            }
            for (let i in this.originalItemMap) {
                let item = this.originalItemMap[i]
                if (!item.doNotDelete) {
                    deleteList.push(item)
                }
            }
            let promiseList = []
            let scenario_id = this.$route.params.scenarioId
            for (let item of addList) {
                promiseList.push(ScenarioService.DictionaryService.create(scenario_id, item))
            }
            for (let item of updateList) {
                promiseList.push(ScenarioService.DictionaryService.update(scenario_id, item.id, item))
            }
            for (let item of deleteList) {
                promiseList.push(ScenarioService.DictionaryService.delete(scenario_id, item.id))
            }

            let i18n = {
                action: this.$t('update'),
                item: this.$t('dictionary')
            }
            Promise.allSettled(promiseList).then(
                resultList => {
                    this.$appService.hideLoading()
                    for (let result of resultList) {
                        if (result.status === 'rejected') {
                            this.$appService.toastError(this.$f.tc('actionFailed', i18n))
                            return
                        }
                    }
                    this.loadDictionary()
                    this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n))
                    this.close()
                }
            )
        },
        scrollBottom () {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.contentDialog.scrollTo({
                        top: this.$refs.contentDialog.scrollHeight
                    })
                })
            })
        },
        deleteAllDictionary () {
            this.$refs.ConfirmDeleteAllDictionary.open(this.$route.params.scenarioId).then(
                () => {
                    this.loadDictionary()
                }
            )
        },
        importDictionary () {
            this.$refs.InputDictionary.click()
        },
        handleFile (event) {
            this.file = event.target.files[0]
            let extFile = event.target.files[0].type
            if (this.file.size <= 1024 * 1024 && $const.ExcelTypes.includes(extFile)) {
                let formData = new FormData()
                formData.append('file', this.file)
                this.$appService.showLoading()
                this.$http.post(
                    `/scenarios/${this.$route.params.scenarioId}/import-dictionary/`,
                    formData,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                ).then(
                    res => {
                        this.$appService.toastSuccess(res.data['detail'])
                    }
                ).finally(() => {
                    this.$appService.hideLoading()
                    this.file = null
                    this.$refs.InputDictionary.value = null
                    this.loadDictionary()
                })

            } else {
                this.$appService.toastError('invalid file')
            }
        },
        downloadTemplate () {
            let scenario_id = this.$route.params.scenarioId
            ScenarioService.getDictionaryTemplate(scenario_id).then(res => {
                this.$utils.saveFile(res.data, this.$filters.replaceSpecialCharacters(this.$utils.nonAccentVietnamese(this.scenario.name + ' - dictionary template')), '.xlsx')
            })
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioDictionary {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .editor-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 12px;
    }

    .dialog-content {
        padding: 12px;
        max-height: calc(85vh - 100px);
        overflow-y: auto;
    }

    .btn-custom {
        margin-right: 8px;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}


table {
    border: 1px solid #96add0;
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    tr {
        height: 48px;
    }

    thead tr:not(.v-datatable__progress) {
        height: 48px !important;
    }

    thead th {
        text-transform: capitalize !important;
        color: #12274F !important;
        background: #E4EDFA;
        text-align: left;
    }

    th:nth-child(1) {
        padding-left: 12px;
    }

    th:nth-child(2) {
        padding-left: 6px;
    }

    tr {
        border-bottom: 1px solid #96add0;
    }

    tr {
        td {
            padding: 0 6px;

            &:first-child {
                padding-left: 12px;
            }
        }
    }
}

.error-message {
    color: red;
    margin-top: 5px;
    font-size: 13px;
    font-family: "open sans", serif;
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-input--selection-controls {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }
}

</style>
